import { render, staticRenderFns } from "./Prescription-medicine-suggestion.vue?vue&type=template&id=c6edd618&scoped=true&"
import script from "./Prescription-medicine-suggestion.vue?vue&type=script&lang=js&"
export * from "./Prescription-medicine-suggestion.vue?vue&type=script&lang=js&"
import style0 from "./Prescription-medicine-suggestion.vue?vue&type=style&index=0&id=c6edd618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6edd618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6edd618')) {
      api.createRecord('c6edd618', component.options)
    } else {
      api.reload('c6edd618', component.options)
    }
    module.hot.accept("./Prescription-medicine-suggestion.vue?vue&type=template&id=c6edd618&scoped=true&", function () {
      api.rerender('c6edd618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FromTemplates/Prescription-medicine-suggestion.vue"
export default component.exports